module.exports = __webpack_public_path__ + "static/media/codice_contatto_totem_sfondo.556e8c69.png";